import { AlertTriangle, CarFront, Flag, Heart, Lock, MessageSquareMore, Share, UserCheck } from 'lucide-react';

export enum NotificationType {
  SignUpSuccessfully = 'SignUpSuccessfully',
  UpdatesPasswordSuccessfully = 'UpdatesPasswordSuccessfully',
  ListingIsHidden = 'ListingIsHidden',
  NewUnreadMessage = 'NewUnreadMessage',
  SharingSuccessfully = 'SharingSuccessfully',
  NewListingInSavedSearch = 'NewListingInSavedSearch',
  ReportListingSuccessfully = 'ReportListingSuccessfully',
  StatusChangedOfTheFavoriteCar = 'StatusChangedOfTheFavoriteCar',
}

export const notificationConfig = {
  [NotificationType.SignUpSuccessfully]: {
    icon: UserCheck,
    color: 'text-blue-600 bg-blue-100',
  },
  [NotificationType.UpdatesPasswordSuccessfully]: {
    icon: Lock,
    color: 'text-green-600 bg-green-100',
  },
  [NotificationType.ListingIsHidden]: {
    icon: Flag,
    color: 'text-red-600 bg-red-100',
  },
  [NotificationType.NewUnreadMessage]: {
    icon: MessageSquareMore,
    color: 'text-purple-600 bg-purple-100',
  },
  [NotificationType.SharingSuccessfully]: {
    icon: Share,
    color: 'text-indigo-600 bg-indigo-100',
  },
  [NotificationType.NewListingInSavedSearch]: {
    icon: CarFront,
    color: 'text-yellow-600 bg-yellow-100',
  },
  [NotificationType.ReportListingSuccessfully]: {
    icon: AlertTriangle,
    color: 'text-red-600 bg-red-100',
  },
  [NotificationType.StatusChangedOfTheFavoriteCar]: {
    icon: Heart,
    color: 'text-pink-600 bg-pink-100',
  },
};
